<template>
  <div class="mini-cart">
    <button class="mini-cart__close" @click="toggleMiniCart">
      <icon-close />
    </button>
    <div v-if="! cartItems.length">
      Cart is empty.
    </div>
    <div v-else class="mini-cart__content">
      <div class="mini-cart__item-count">
        You have {{ cartItems.length }} {{ cartItems.length === 1 ? 'item' : 'items' }} in your cart.
      </div>
      <mini-cart-item
        v-for="cartItem in cartItems"
        :key="cartItem"
        :cart-item="cartItem" />
      <div class="mini-cart__bonus-content">
        <free-picks-free-pick-panel compact />
      </div>
      <nuxt-link class="mini-cart__action" to="/cart" @click="toggleMiniCart">
        View Cart
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "~/stores/cart";
import { defineAsyncComponent } from '#imports';

const MiniCartItem = defineAsyncComponent(() => import('~/components/MiniCartItem.vue'));
const IconClose = defineAsyncComponent(() => import('~/assets/icons/IconClose.svg'));

export default {
  components: {
    MiniCartItem,
    IconClose,
  },
  setup() {
    const cartStore = useCartStore();

    return { cartStore }
  },
  computed: {
    cartItems() {
      return this.cartStore.getCurrentCartItems ?? []
    }
  },
  methods: {
    toggleMiniCart() {
      this.cartStore.closeMiniCart()
    }
  },
}
</script>

<style lang="scss">
@use "~/common/scss/mq";
@use "~/common/scss/variables";
@use "~/common/scss/button";
@use "~/common/scss/helpers";

.mini-cart {
  background: #fff;
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--menu-height));
  overflow: auto;
  padding: 1em;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 999;

  @include mq.mq(variables.$mq-3-min) {
    border-left: solid 1px #{variables.$colorGrey};
    max-width: helpers.px-to-rem(300);
  }

  &__close {
    align-self: end;
    font-size: helpers.px-to-rem(20);
  }

  &__action {
    align-self: center;
    margin-bottom: 1em;

    @include button.buttonWhiteBlack();
    @include button.buttonMediumLarge(true);

    width: calc(100% - 1em);
    &:hover {
      border-color: #000;
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin-top: 1em;
  }
  &__bonus-content {
    text-align: center;
  }
  &__item-count {
    font-size: helpers.px-to-rem(16);
    margin-bottom: 0.5em;
  }
}
</style>
